import { useIsFetching } from '@tanstack/react-query';
import {
  createContext,
  ReactNode,
  useCallback,
  useContext,
  useEffect,
  useState,
} from 'react';

type SurveyContextType = {
  pageLoaded: boolean;
  markPageLoaded: () => void;
};

const SurveyContext = createContext<SurveyContextType | undefined>(undefined);

export const SurveyProvider = ({ children }: { children: ReactNode }) => {
  const isFetching = useIsFetching();
  const [manuallyMarkedLoaded, setManuallyMarkedLoaded] = useState(false);
  const [initialCheckDone, setInitialCheckDone] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setInitialCheckDone(true);
    }, 150);

    return () => clearTimeout(timer);
  }, []);

  const autoDetectedLoaded = initialCheckDone && isFetching === 0;
  const pageLoaded = manuallyMarkedLoaded || autoDetectedLoaded;

  const markPageLoaded = useCallback(() => {
    setManuallyMarkedLoaded(true);
  }, []);

  return (
    <SurveyContext.Provider value={{ pageLoaded, markPageLoaded }}>
      {children}
    </SurveyContext.Provider>
  );
};

export const useSurvey = () => {
  const context = useContext(SurveyContext);
  return context;
};
